import { doc, getDoc } from 'firebase/firestore';

import { db } from '@src/firebase/firebase';
import PieChart from '@src/models/PieChart';
import { ACTIONS } from '@src/util/firebase-operations/constants';
import {
  getRouteToPieChartByDivision,
  getRouteToPieChartByOrg,
} from '@src/util/firebase-operations/constants';
import { createOperation } from '@src/util/firebase-operations/utils/createOperation';
import safeExecute from '@src/util/safeExecute';

class PieChartRepository {
  constructor() {
    this.pieChart = new PieChart();
  }

  getCollectionPath(orgId, divId = null, boardId) {
    if (divId) {
      return getRouteToPieChartByDivision(orgId, divId, boardId);
    }
    return getRouteToPieChartByOrg(orgId, boardId);
  }

  async create({ data, orgId, divId = null, boardId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      this.pieChart.setData(data);
      const res = await createOperation(collectionPath, null, this.pieChart, ACTIONS.CREATE);
      return res;
    }).catch(error => {
      throw error;
    });
  }

  async update({ data, orgId, divId = null, boardId, chartId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      this.pieChart.setData(data);
      const pieChartData = this.pieChart.toUpdate();
      await createOperation(collectionPath, chartId, pieChartData, ACTIONS.UPDATE);
      return pieChartData;
    }).catch(error => {
      throw error;
    });
  }

  async get({ orgId, divId = null, boardId, chartId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      const pieChartRef = doc(db, collectionPath, chartId);
      const pieChartDoc = await getDoc(pieChartRef);
      
      if (pieChartDoc.exists()) {
        return { id: pieChartDoc.id, ...pieChartDoc.data() };
      }
      return null;
    }).catch(error => {
      throw error;
    });
  }
}

export default PieChartRepository;
